import { FormattedMessage } from "react-intl"

import {
  OuterWrapper,
  ScrollWrapper,
} from "../../components/ui/styles/Containers"
import { FormWrapper } from "../../components/ui/styles/FormElementStyles"
import { ErrorHeading, SubHeading } from "../../components/ui/textStyles"

export const CommerceError = () => {
  return (
    <OuterWrapper>
      <ScrollWrapper>
        <FormWrapper>
          <ErrorHeading>
            <FormattedMessage
              id="checkoutError.title.default"
              defaultMessage="We're sorry, something went wrong."
            />
          </ErrorHeading>
          <SubHeading>
            <FormattedMessage
              id="general.error"
              defaultMessage="Please refresh the page and try again."
            />
          </SubHeading>
        </FormWrapper>
      </ScrollWrapper>
    </OuterWrapper>
  )
}
